/**
 * 导入自定义i18n
 *
 * 使用方式：{{ $t("person.name") }}
 */

import { createI18n } from 'vue-i18n';


/**
 * 自定义的国际化
 */
import ZH from './zh.js';
import EN from './en.js';


const messages = {
    zh: { ...ZH  },
    en: { ...EN  },
};


const i18n = createI18n({
    // 如果你不需要支持 Vue 2 的 legacy 模式
    legacy: false,
    // 可全局注入使用
    globalInjection: true,
    // 默认语言
    locale: localStorage.getItem('lang') || 'zh',
    messages
});
export default i18n;